import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { Subscription, throwError } from 'rxjs';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoderService } from './shared/services/loder.service';
import { fadeAnimation } from './shared/services/animations';
import moment from 'moment';
import { Title } from '@angular/platform-browser';
import { APIConfing } from './shared/services/apiconfing.service';
// import { NotificationServiceService } from './shared/services/notification.service';
import { BaseRequestService } from './shared/services/base-request.service';
import { CommonService } from './shared/services/common.service';
import * as CryptoJS from 'crypto-js';
import { catchError } from 'rxjs/operators';
import { EncryptDecryptService } from './shared/services/encrypt-decrypt.service';
import { CommonPreLoadedService } from './core/services/common/common-pre-loaded.service';

var response: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false/* ,
  animations: [fadeAnimation] */
})
export class AppComponent implements OnInit, OnDestroy {
  year: any;
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }
  isShowIndicator = true;
  subAuth: Subscription;
  isWhiteLabled: any;
  isCareerPortal = false;
  consultantDetails: any = {};
  cDate: any;
  switchEnabled = false;

  constructor(private authService: AuthService,
    private baseRequset: BaseRequestService,
    private screen: ScreenService,
    public appInfo: AppInfoService,
    public common: CommonService,
    private enc: EncryptDecryptService,
    private commonLoad: CommonPreLoadedService
    , private router: Router
    , private pageTitle: Title
    , private indicator: LoderService) {
    if (APIConfing.data.isWhiteLabled != 'No')
      pageTitle.setTitle(APIConfing.data.isWhiteLabled);
    this.isWhiteLabled = APIConfing.data.isWhiteLabled;
    this.switchEnabled = APIConfing.data.switchEnabled;
    this.subAuth = this.isAutorized();
    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        // if (this.router.url === '/login' || this.router.url === '/') {
        //   this.isCareerPortal = false;
        // }
      }
      if (routerEvent instanceof NavigationEnd) {
        if (this.isAutorized()) {
          this.fnGetSessionDS({});
        }
        setTimeout(() => {
          //   this.indicator.hide();
        }, 100);
      }
    });
  }

  ngOnInit() {
    this.year = moment(new Date()).format('YYYY');
    this.loadScript(`https://maps.googleapis.com/maps/api/js?key=` + APIConfing.data.apiConfing.GOOGLE_API_KEY + `&libraries=places&language=en`).then(() => {
    });
  }
  loadScript(name: string) {
    return new Promise<void>((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = name;
      document.getElementsByTagName('head')[0].appendChild(script);
      resolve()
    });
  }
  isAutorized() {
    let isLoggedIn: any;
    this.authService.isLoggedIn.subscribe((data: any) => {
      isLoggedIn = data;
    });
    return isLoggedIn;
  }
  ngOnDestroy() {
    this.subAuth.unsubscribe();
    this.year = null;
  }
  fnGetSessionDS(data) {
    const SessionData: any = {
    };
    this.baseRequset.fnpost('/CSS/Consultant/GetConsultantSessionDetails', SessionData)
      .subscribe((dataRESP: any) => {
        if (dataRESP && dataRESP.code === this.baseRequset.status.success) {
          response = JSON.parse(this.enc.decryptUsingAES256(dataRESP.dataObject));
          if (dataRESP && response && response.length) {
            if (response[0].restrictESSAccess || (response[0].employmentStatus > 2)) {
              this.authService.logout();
            } else {
              if (response[0].isMyBirthDay) {
                localStorage.setItem(this.enc.encryptUsingAES256('isMyBirthDay'), btoa(response[0].isMyBirthDay));
              } else localStorage.setItem(this.enc.encryptUsingAES256('isMyBirthDay'), btoa('0'));
              this.common.fnIsSetCookies(data);
              response[0].ESSToken = localStorage.getItem(this.enc.encryptUsingAES256('ESS_token'));
              response[0].RefreshToken = sessionStorage.getItem(this.enc.encryptUsingAES256('ESS_Refresh_token'));
              sessionStorage.setItem(this.enc.encryptUsingAES256('esstoken'), this.enc.encryptUsingAES256(JSON.stringify(response)));
              sessionStorage.setItem(this.enc.encryptUsingAES256('isActive'), 'true');
                 this.commonLoad.sendAuthInfo(response);
              setTimeout(() => {
                this.fnGetConsultantBasicDetails(response[0]);
              }, 1000);
            }
          } else {
            this.authService.logout();
          }
        } else if (dataRESP.code === 'E002') {
          // this.toastrService.error(APIConfing.data.E002);
        } else if (dataRESP.code === 'E001') {
        } else if (dataRESP.code === this.baseRequset.warning.code) {
          // this.toastrService.error(dataRESP.message, 'Error');
        } else {
        }
      }, error => {
        // this.toastrService.error(APIConfing.data.E002, 'Error');
      });
  }
  fnGetConsultantBasicDetails(session) {
    const getBasicInfo = {
    };
    this.baseRequset.fnpost('/CSS/Consultant/GetConsultantBasicDetails', getBasicInfo)
      .pipe(catchError(err => throwError(err)))
      .subscribe((objRESP: any) => {
        if (objRESP && objRESP.code === this.baseRequset.status.success) {
          if (objRESP && objRESP.dataObject && objRESP.dataObject.length) {
            this.consultantDetails = objRESP.dataObject[0];
            if (this.consultantDetails.lwd) {
              this.fnCheckLogin(this.consultantDetails.lwd);
            } else if (session.restrictESSAccess || (session.employmentStatus > 2)) {
              this.authService.logout();
            } else {
              if (response[0].isESS === 'ESS') {
                if ((response[0].isOfferReleased === 1 || response[0].isHRLetterReleased === 1 || response[0].isAssetLetterReleased === 1) || (response[0].restrictEmpLogin)) {
                  this.router.navigate(['/Offer-Acceptance']);
                } else {
                  // this.router.navigate(['/ESS-Home']);
                }
              } else {
                if ((response[0].isOfferReleased === 1 || response[0].isHRLetterReleased === 1 || response[0].isAssetLetterReleased === 1) || (response[0].restrictEmpLogin)) {
                  this.router.navigate(['/Offer-Acceptance']);
                } else {
                  // this.router.navigate(['/home']);
                }
              }
            }
          } else {
            this.authService.logout();
          }
        } else if (objRESP.code === 'E002') {
          // this.toastrService.error(APIConfing.data.E002);
        } else if (objRESP.code === 'E001') {
          // this.toastrService.error(objRESP.message, 'Error');
          this.consultantDetails = null;
        } else if (objRESP.code === this.baseRequset.warning.code) {
          this.consultantDetails = null;
        } else {
          const tmpResult = null;
          this.consultantDetails = null;
        }
      }, err => {
        // this.toastrService.error(APIConfing.data.E002, 'Error')
      }
      );
  }
  fnDateFormat(getDate) {
    if (getDate) {
      return moment(getDate).format('DD-MMM-YYYY');
    }
  }
  fnCheckLogin(lwdDte: any) {
    const lwdDate = moment(lwdDte).format('DD-MMM-YYYY');
    this.cDate = this.fnDateFormat(moment());
    const date1 = new Date(lwdDate);
    const date2 = new Date(this.cDate);
    if (date1 < date2) {
      this.authService.logout();
    } else {
    }
  }

}
